import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  CognitoAuthService,
  EnrichedUserWithPermissionsAndClients,
} from '@techspert-io/auth';
import { combineLatest } from 'rxjs';
import { tap } from 'rxjs/operators';
import { UserPermission } from '../../../features/auth/models/permissions';
import { OmnisearchService } from '../../../features/omnisearch/services/omnisearch.service';
import { TimezonePreferenceService } from '../../services/timezone-preference.service';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss'],
  standalone: false,
})
export class TopBarComponent implements OnInit {
  showOmnisearch = false;
  isOmnisearchAuthorised = false;
  omnisearchSalesCarrot = false;
  innerWidth: number;

  get loggedInUser(): EnrichedUserWithPermissionsAndClients {
    return this.cognitoAuthService.loggedInUser;
  }

  get showReportsItem(): boolean {
    return (
      this.loggedInUser &&
      this.loggedInUser.permissions.has(UserPermission.ClientReportsRead) &&
      Object.values(this.loggedInUser.clients).some(
        (d) => d.features.clientContractReportEnabled
      )
    );
  }

  constructor(
    private cognitoAuthService: CognitoAuthService,
    private omnisearchService: OmnisearchService,
    private router: Router,
    protected timezonePreferenceService: TimezonePreferenceService
  ) {
    this.configureOmnisearch();
  }

  ngOnInit() {
    combineLatest([
      this.omnisearchService.omnisearchEnabled$,
      this.cognitoAuthService.loggedInConnect$,
    ])
      .pipe(tap(([enabled]) => (this.isOmnisearchAuthorised = enabled)))
      .subscribe();

    this.omnisearchService
      .getShowOmnisearch()
      .pipe(tap((show) => (this.showOmnisearch = show)))
      .subscribe();
  }

  @HostListener('window:resize', ['$event'])
  onResize(_?: Event) {
    this.configureOmnisearch();
  }

  showOmni() {
    this.omnisearchService.setShowOmnisearch(true);
    this.omnisearchService.setFocused(true);
  }

  logout() {
    this.cognitoAuthService.logOut().subscribe();
  }

  navigateRoot() {
    this.router.navigate(['/']);
  }

  private configureOmnisearch() {
    this.innerWidth = window.innerWidth;
    this.omnisearchService.setShowOmnisearch(window.innerWidth > 600);
  }
}
